var _ = require('underscore');
var Section = require('submissions/pages/Section/Section');

require('./Rules.less');

var AwardsADGContent = require('front/components/AwardsADGContent/AwardsADGContent');
var Banner = require('submissions/components/Banner/Banner');

module.exports = Section.extend({

    el: '.Rules',

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'AwardsADGContent': {selector: '.AwardsADGContent', viewConstructor: AwardsADGContent},
        'Banner': {selector: '.Banner', viewConstructor: Banner}
    },


    events: {
    },


    initialize: function (options) {
        this.options = options || {};

        Section.prototype.initialize.call(this, options);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/pages/Rules/Rules.js
// module id = 134
// module chunks = 0